import { lazy } from "react";

export const AdminDoctorsAsync = lazy(() => import("./Doctors"));
